import BunkeyAPI from "../api/BunkeyAPI";
import {
  CLIENT_EMPTY,
  CLIENT_GET_DATA,
  CLIENT_GET_DATA_SUCCESS,
  CLIENT_GET_DATA_FAILURE,
  CLIENT_BREADCRUMB_GET_DATA,
  CLIENT_BREADCRUMB_GET_DATA_SUCCESS,
  CLIENT_BREADCRUMB_GET_DATA_FAILURE,
  CLIENT_ALL_BREADCRUMB_GET_DATA,
  CLIENT_ALL_BREADCRUMB_GET_DATA_SUCCESS,
  CLIENT_ALL_BREADCRUMB_GET_DATA_FAILURE,
  CLIENT_ROOT_FOLDERS_GET_DATA,
  CLIENT_ROOT_FOLDERS_GET_DATA_SUCCESS,
  CLIENT_ROOT_FOLDERS_GET_DATA_FAILURE,
  CLIENT_CREATE_FOLDER,
  CLIENT_CREATE_FOLDER_SUCCESS,
  CLIENT_CREATE_FOLDER_FAILURE,
  CLIENT_CREATE_ROOT_FOLDER_SUCCESS,
  CLIENT_SET_UPLOADING,
  CLIENT_UNSET_UPLOADING,
  CLIENT_DOWNLOAD_PROGRESS,
  CLIENT_EDIT_FOLDER,
  CLIENT_EDIT_FOLDER_SUCCESS,
  CLIENT_EDIT_FOLDER_FAILURE,
  CLIENT_DELETE_FOLDER,
  CLIENT_DELETE_FOLDER_SUCCESS,
  CLIENT_DELETE_FOLDER_FAILURE,
  CLIENT_MOVE_FOLDER,
  CLIENT_MOVE_FOLDER_SUCCESS,
  CLIENT_MOVE_FOLDER_FAILURE,
  CLIENT_SHARE_FOLDER,
  CLIENT_SHARE_FOLDER_SUCCESS,
  CLIENT_SHARE_FOLDER_FAILURE,
  CLIENT_CHANGE_LOGO,
  CLIENT_CHANGE_LOGO_SUCCESS,
  CLIENT_CHANGE_LOGO_FAILURE,
  CLIENT_SET_PID,
  CREATE_CLIENT_LIST,
  CREATE_CLIENT_LIST_SUCCESS,
  CREATE_CLIENT_LIST_FAILURE,
  DELETE_CLIENT_LIST,
  DELETE_CLIENT_LIST_SUCCESS,
  DELETE_CLIENT_LIST_FAILURE,
  UPDATE_CLIENT_LIST,
  UPDATE_CLIENT_LIST_SUCCESS,
  UPDATE_CLIENT_LIST_FAILURE,
  SET_QTY_FILES_ERROR,
  HANDLE_USER_ATTEMPS,
  SET_NUMBER_ATTEMPS,
  HANDLE_IS_TOUR_OPEN,
  HANDLE_IS_FETCHING_SAURON_REPORT,
  SHOW_VERSION_ASSET,
  HIDE_VERSION_ASSET,
  ADD_FILE_VERSION_ASSET,
  REMOVE_FILE_VERSION_ASSET,
  UPDATE_FILE_PROGRESS_VERSION_ASSET,
  SET_UPLOAD_OBJECT_TO_FILE_VERSION_ASSET,
  SET_ERROR_STATE_TO_FILE_VERSION_ASSET,
  SET_SUCCESS_STATE_TO_FILE_VERSION_ASSET,
  SET_IS_UPLOADING_VERSION,
  EMPTY_VERSION_ASSET,
  SET_VERSION_TAGS_VERSION_ASSET,
  CANCEL_UPLOAD_VERSION,
  UNSET_IS_UPLOADING_VERSION,
  ERROR_UPLOAD_VERSION,
  SET_TAGS_UPLOAD_VERSION,
  REMOVE_TAG_ASSET_VERSION,
  SET_USERS_OPTIONS,
  SET_MENTIONED_USERS,
  CREATE_CLIENT_MEDIA,
  CREATE_CLIENT_MEDIA_FAILURE,
  CREATE_CLIENT_MEDIA_SUCCESS,
  CREATE_CLIENT_STATUS,
  CREATE_CLIENT_STATUS_FAILURE,
  CREATE_CLIENT_STATUS_SUCCESS,
  DELETE_CLIENT_MEDIA,
  DELETE_CLIENT_MEDIA_FAILURE,
  DELETE_CLIENT_MEDIA_SUCCESS,
  DELETE_CLIENT_STATUS,
  DELETE_CLIENT_STATUS_FAILURE,
  DELETE_CLIENT_STATUS_SUCCESS,
  CLIENT_END_FOLDER_ACTION,
  SHARE_FOLDER_RESET,
  CLIENT_DATA_CLEAN,
  UPDATE_METADATA_CLIENT,
  CLIENT_ROOT_FOLDER_NAVBAR
} from "../constants/client-types";

import store from "../store";

import { SEARCH_EMPTY } from "../constants/search-types";
import { ASSET_EXPLORE_EMPTY } from "../constants/assets-explore-types";
import { ASSET_ROOT_EMPTY } from "../constants/assets-root-types";
import { ASSET_SHARED_EMPTY } from "../constants/assets-share-types";
import { ASSET_FAVORITES_EMPTY } from "../constants/assets-favorites-types";
import { ASSET_LAST_UPLOAD_EMPTY } from "../constants/assets-lastupload-types";
import { ASSET_CONFIRM_EMPTY } from "../constants/assets-confirm-types";
import { RESET_STATUS_ASSET } from "../constants/comment-types";
import { ASSET_RIGHTS_STATE_UPDATED } from "../constants/rights-constants";

import {
  getRoot,
  setRootActiveView,
  setEditRootAsset,
  deleteRootAsset,
  multiDeleteRootAsset,
  setSelectEditRootAsset,
  unsetSelectEditRootAsset,
  setSelectShareRootAsset,
  unsetSelectShareRootAsset,
  setCheckRootAsset,
  unsetCheckRootAsset,
  activateRootOptions,
  deactivateRootOptions,
  isDoneMultipeRootOptions,
  moveMultiselectRootAsset
} from "./AssetsRootAction";

import {
  getLastUploads,
  multiDeleteLastUploadAsset,
  setLastUploadActiveView,
  setEditLastUploadAsset,
  setSelectLastUploadAsset,
  unsetSelectLastUploadAsset,
  setSelectEditLastUploadAsset,
  deleteLastUploadAsset,
  unsetSelectEditLastUploadAsset,
  setSelectExpandLastUploadAsset,
  unsetSelectExpandLastUploadAsset,
  setSelectShareLastUploadAsset,
  unsetSelectShareLastUploadAsset,
  moveLastUploadAsset,
  setCheckLastUploadAsset,
  unsetCheckLastUploadAsset,
  activateLastUploadsOptions,
  deactivateLastUploadsOptions,
  isDoneMultipeLastUploadsOptions,
  moveMultiselectLastUploadAsset
} from "./AssetsLastUploadAction";

import {
  getFavorites,
  setFavoritesActiveView,
  setEditFavoritesAsset,
  multiDeleteFavoritesAsset,
  setSelectFavoriteAsset,
  unsetSelectFavoriteAsset,
  deleteFavoritesAsset,
  setSelectEditFavoritesAsset,
  unsetSelectEditFavoritesAsset,
  setSelectExpandFavoritesAsset,
  unsetSelectExpandFavoritesAsset,
  setSelectShareFavoritesAsset,
  unsetSelectShareFavoritesAsset,
  moveFavoritesAsset,
  setCheckFavoritesAsset,
  unsetCheckFavoritesAsset,
  activateFavoritesOptions,
  deactivateFavoritesOptions,
  isDoneMultipeFavoritesOptions,
  moveMultiselectFavoritesAsset
} from "./AssetsFavoritesAction";
import {
  setExploreActiveView,
  setEditExploreAsset,
  setSelectExploreAsset,
  multiDeleteExploreAsset,
  unsetSelectExploreAsset,
  deleteExploreAsset,
  setSelectEditExploreAsset,
  unsetSelectEditExploreAsset,
  setSelectExpandExploreAsset,
  unsetSelectExpandExploreAsset,
  setSelectShareExploreAsset,
  unsetSelectShareExploreAsset,
  moveExploreAsset,
  setCheckExploreAsset,
  unsetCheckExploreAsset,
  activateExploreOptions,
  deactivateExploreOptions,
  isDoneMultipeExploreOptions,
  moveMultiselectExploreAsset
} from "./AssetsExploreAction";

import {
  setSharedActiveView,
  setEditSharedAsset,
  setSelectSharedAsset,
  unsetSelectSharedAsset,
  deleteSharedAsset,
  setSelectEditSharedAsset,
  unsetSelectEditSharedAsset,
  setSelectExpandSharedAsset,
  unsetSelectExpandSharedAsset,
  setSelectShareSharedAsset,
  unsetSelectShareSharedAsset,
  moveSharedAsset,
  getShared,
  setCheckSharedAsset,
  unsetCheckSharedAsset,
  activateSharedOptions,
  deactivateSharedOptions,
  isDoneMultipeSharedOptions,
  multiDeleteSharedAsset,
  moveMultiselectSharedAsset
} from "./AssetsShareAction";

import {
  setSelectSearcher,
  unsetSelectSearcher,
  setSearchActiveView,
  setEditSearchAsset,
  setSelectEditSearchAsset,
  unsetSelectEditSearchAsset,
  setSelectExpandSearchAsset,
  unsetSelectExpandSearchAsset,
  setSelectShareSearchAsset,
  unsetSelectShareSearchAsset,
  deleteSearchAsset,
  moveSearchAsset,
  getSearchResult,
  getAdvancedSearchResult,
  setCheckSearcherAsset,
  unsetCheckSearcherAsset,
  activateSearchOptions,
  deactivateSearchOptions,
  isDoneMultipeSearchOptions,
  multiDeleteSearchAsset,
  moveMultiselectSearchAsset
} from "./SearchAction";

import {
  setSelectExpandPublicSharedAsset,
  unsetSelectExpandPublicSharedAsset,
  setSelectPublicShared,
  unsetSelectPublicShared,
  setPublicSharedActiveView
} from "./AssetsPublicSharedAction";

import { getExplore } from "./AssetsExploreAction";
import { setSelectedItem } from "../actions/CommentAction";

import {
  SET_USER_CLIENT_ROLE,
  SET_USER_CLIENT_ROLE_SUCCESS,
  SET_USER_CLIENT_ROLE_FAILURE
} from "../constants/login-types";
import { sendNotification, LIMITE_PAGINA_CARPETA } from "../utils";
import { handleStatusSocket } from "./NotificationAction";

import { getGroupByClientIdUserId } from "./GroupAction";
import Socket from "../utils/sockets";
import { getPlanServices } from "./PlanServicesAction";
import { CLOSE_RIGHTS_VIEWER } from "../constants/rights-report-types";

/**
 * @description Obtiene cliente por id
 * @param {*} clientId
 * @returns
 */
export const getClientById = clientId => {
  return dispatch => {
    dispatch({ type: CLIENT_GET_DATA });
    dispatch(handleStatusSocket(true));
    Socket.getInstance().close();
    Socket.getInstance().open();

    return new Promise((resolve, reject) => {
      BunkeyAPI({
        url: `clients/${clientId}`,
        method: "GET"
      })
        .then(resp => {
          dispatch({
            type: CLIENT_GET_DATA_SUCCESS,
            payload: resp
          });
          resolve();
        })
        .catch(err => {
          dispatch({
            type: CLIENT_GET_DATA_FAILURE,
            payload: err
          });
          reject();
        });
    });
  };
};
export const getClientDataById = clientId => {
  return dispatch => {
    dispatch({ type: CLIENT_GET_DATA });

    return new Promise((resolve, reject) => {
      BunkeyAPI({
        url: `clients/${clientId}`,
        method: "GET"
      })
        .then(resp => {
          dispatch({
            type: CLIENT_GET_DATA_SUCCESS,
            payload: resp
          });
          resolve();
        })
        .catch(err => {
          dispatch({
            type: CLIENT_GET_DATA_FAILURE,
            payload: err
          });
          reject();
        });
    });
  };
};

export const getUserClientRole = clientId => {
  return dispatch => {
    dispatch({ type: SET_USER_CLIENT_ROLE });

    return new Promise((resolve, reject) => {
      BunkeyAPI({
        url: `users/me/workspaces/${clientId}`,
        method: "GET"
      })
        .then(response => {
          dispatch({
            type: SET_USER_CLIENT_ROLE_SUCCESS,
            clientRole: response.data.role
          });
          resolve();
        })
        .catch(err => {
          dispatch({
            type: SET_USER_CLIENT_ROLE_FAILURE,
            payload: err
          });
          reject();
        });
    });
  };
};

export const setEmptyClient = () => {
  return dispatch => {
    dispatch({ type: CLIENT_EMPTY });
    dispatch({ type: SEARCH_EMPTY });
    dispatch({ type: ASSET_EXPLORE_EMPTY });
    dispatch({ type: ASSET_ROOT_EMPTY });
    dispatch({ type: ASSET_SHARED_EMPTY });
    dispatch({ type: ASSET_FAVORITES_EMPTY });
    dispatch({ type: ASSET_LAST_UPLOAD_EMPTY });
    dispatch({ type: ASSET_CONFIRM_EMPTY });
    dispatch(handleStatusSocket(false));
    Socket.getInstance().disconnect(true);
  };
};

export const getBreadCrumbsByClient = (workClient, folderId = null) => {
  const user = store.getState().authUser.user;
  const rootFolder = folderId || store.getState().client.root;
  return dispatch => {
    dispatch({ type: CLIENT_BREADCRUMB_GET_DATA });
    BunkeyAPI({
      // url: `/clients/${workClient}/folders`,
      url: `/clients/${workClient}/breadcrumb/${rootFolder}`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: CLIENT_BREADCRUMB_GET_DATA_SUCCESS,
          payload: {
            data: resp.data,
            user: user
          }
        });
        dispatch({ type: CLIENT_END_FOLDER_ACTION });
      })
      .catch(err => {
        dispatch({
          type: CLIENT_BREADCRUMB_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

/**
 * @description Obtiene todos los breadcrumbs de un cliente, utilizado sólo para CRUD Groups
 * @param {*} workClient
 * @param {*} folderId
 * @returns
 */
export const getRootFoldersByClient = (groupId) => {
  const workclient = store.getState().client.workclient;
  return dispatch => {
    dispatch({ type: CLIENT_ROOT_FOLDERS_GET_DATA });
    // #2 (Falabella): al editar un grupo mandamos su id para que el backend devuelva
    // el tri-estado real (descendantCount/selectedDescendantCount) por carpeta raíz.
    const qs = groupId ? `?groupId=${groupId}` : "";
    BunkeyAPI({ url: `/clients/${workclient}/breadcrumb/roots${qs}`, method: "GET" })
      .then(resp => {
        dispatch({ type: CLIENT_ROOT_FOLDERS_GET_DATA_SUCCESS, payload: { data: resp.data } });
      })
      .catch(err => {
        dispatch({ type: CLIENT_ROOT_FOLDERS_GET_DATA_FAILURE, payload: err });
      });
  };
};

export const fetchDirectChildFolders = (clientId, folderId, groupId) => {
  const qs = groupId ? `?groupId=${groupId}` : "";
  return BunkeyAPI({ url: `/clients/${clientId}/breadcrumb/direct-children/${folderId}${qs}`, method: "GET" })
    .then(resp => resp.data);
};

/**
 * @description Devuelve los _id de TODAS las carpetas del cliente. Se usa para el
 * switch "seleccionar todas las carpetas" del mantenedor de grupos: bajo lazy-load
 * el árbol ya no viene completo, así que necesitamos la lista total aparte.
 */
export const fetchAllFolderIds = (clientId) => {
  return BunkeyAPI({ url: `/clients/${clientId}/breadcrumb/all-folder-ids`, method: "GET" })
    .then(resp => resp.data);
};

/**
 * @description Devuelve los _id de TODAS las carpetas descendientes (subárbol completo)
 * de una carpeta. Se usa en el mantenedor de grupos para que marcar/desmarcar una carpeta
 * colapsada arrastre a todo su subárbol, aunque el árbol se cargue nivel a nivel (lazy-load).
 */
export const fetchDescendantFolderIds = (clientId, folderId) => {
  return BunkeyAPI({ url: `/clients/${clientId}/breadcrumb/descendant-ids/${folderId}`, method: "GET" })
    .then(resp => resp.data);
};

export const getAllBreadCrumbsByClient = () => {
  const workclient = store.getState().client.workclient;
  return dispatch => {
    dispatch({ type: CLIENT_ALL_BREADCRUMB_GET_DATA });
    BunkeyAPI({
      url: `/clients/${workclient}/breadcrumb/all`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: CLIENT_ALL_BREADCRUMB_GET_DATA_SUCCESS,
          payload: {
            data: resp.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CLIENT_ALL_BREADCRUMB_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const createFolder = (
  workClient,
  folder,
  name,
  root,
  folderselect,
  longDescription,
  tagProtocol,
  handleHideCRUDFolder
) => {
  const {
    // assetsRoot,
    // assetsLastUploads,
    // assetsFavorites,
    // assetsShared,
    client,
    assetsExplore
  } = store.getState();

  return (dispatch, getState) => {
    const { authUser: user } = getState();
    const isOperator = user.role !== "admin" && user.clientRole !== "admin";
    dispatch({ type: CLIENT_CREATE_FOLDER });
    BunkeyAPI({
      url: `/clients/${workClient}/objects/${folder}`,
      method: "POST",
      data: {
        name,
        type: "folder",
        longDescription,
        tagProtocol
      }
    })
      .then(resp => {
        dispatch({
          type:
            folder !== root
              ? CLIENT_CREATE_FOLDER_SUCCESS
              : CLIENT_CREATE_ROOT_FOLDER_SUCCESS
        });
        if (isOperator) {
          dispatch(getGroupByClientIdUserId(workClient));
        }
        Socket.getInstance().emit("breadcrumbs_client_refresh", {
          workClient,
          // dataAssetsRoot: assetsRoot.data,
          // dataAssetsLastUploads: assetsLastUploads.data,
          // dataAssetsFavorites: assetsFavorites.data,
          // dataAssetsShared: assetsShared.data,
          explore: {
            dataAssetsExplore: assetsExplore.data,
            folderSelect: assetsExplore.folderselect,
            page: assetsExplore.page,
            limit: assetsExplore.limit
          },
          root: client.root,
          isFolderRelated: true,
          issuingUser: user.user
        });

        if (folderselect) {
          dispatch(getBreadCrumbsByClient(workClient, folderselect));
          if (folder === folderselect) {
            dispatch(
              getExplore(
                workClient,
                folderselect,
                1,
                undefined,
                undefined,
                undefined,
                20
              )
            );
          } else {
            dispatch(getRoot(workClient, root));
          }
        } else {
          dispatch(getBreadCrumbsByClient(workClient));
          dispatch(getRoot(workClient, root));
          dispatch(getLastUploads(workClient, root));
        }
        handleHideCRUDFolder();
      })
      .catch(err => {
        dispatch({
          type: CLIENT_CREATE_FOLDER_FAILURE,
          payload: err
        });
      });
  };
};

export const editFolder = (
  workClient,
  folder,
  name,
  root,
  folderselect,
  longDescription,
  tagProtocol,
  handleHideCRUDFolder
) => {
  const {
    // assetsRoot,
    // assetsLastUploads,
    // assetsFavorites,
    // assetsShared,
    client,
    assetsExplore,
    authUser: user
  } = store.getState();

  return dispatch => {
    dispatch({ type: CLIENT_EDIT_FOLDER });

    const params = name
      ? {
        name,
        longDescription,
        tagProtocol
      }
      : {
        longDescription,
        tagProtocol
      };

    BunkeyAPI({
      url: `/clients/${workClient}/objects/${folder}`,
      method: "PUT",
      data: params
    })
      .then(resp => {
        dispatch({
          type: CLIENT_EDIT_FOLDER_SUCCESS,
          payload: {
            data: {
              folder: folder,
              name: name,
              longDescription: longDescription,
              tagProtocol: tagProtocol
            }
          }
        });
        handleHideCRUDFolder();
        Socket.getInstance().emit("breadcrumbs_client_refresh", {
          workClient,
          // dataAssetsRoot: assetsRoot.data,
          // dataAssetsLastUploads: assetsLastUploads.data,
          // dataAssetsFavorites: assetsFavorites.data,
          // dataAssetsShared: assetsShared.data,
          explore: {
            dataAssetsExplore: assetsExplore.data,
            folderSelect: assetsExplore.folderselect,
            page: assetsExplore.page,
            limit: assetsExplore.limit
          },
          root: client.root,
          isFolderRelated: true,
          issuingUser: user.user
        });

        if (folderselect) {
          dispatch(getBreadCrumbsByClient(workClient, folderselect));
          dispatch(
            getExplore(
              workClient,
              folderselect,
              1,
              undefined,
              undefined,
              undefined,
              20
            )
          );
        } else {
          dispatch(getBreadCrumbsByClient(workClient));
          dispatch(getRoot(workClient, root));
          dispatch(getFavorites(workClient, root));
          dispatch(getLastUploads(workClient, root));
        }
      })
      .catch(err => {
        handleHideCRUDFolder();
        dispatch({
          type: CLIENT_EDIT_FOLDER_FAILURE,
          payload: err
        });
      });
  };
};

export const moveFolder = (
  workClient,
  folderId,
  folderDestination,
  folderselect,
  root,
  intl,
  handleHideCRUDFolder
) => {
  const {
    // assetsRoot,
    // assetsLastUploads,
    // assetsFavorites,
    // assetsShared,
    client,
    assetsExplore,
    authUser: user
  } = store.getState();

  return dispatch => {
    dispatch({ type: CLIENT_MOVE_FOLDER });
    BunkeyAPI({
      url: `/clients/${workClient}/objects/${folderId}`,
      method: "PUT",
      data: {
        action: "move",
        folder: folderDestination
      }
    })
      .then(resp => {
        dispatch({ type: CLIENT_MOVE_FOLDER_SUCCESS });
        if (handleHideCRUDFolder) {
          handleHideCRUDFolder();
        }
        Socket.getInstance().emit("breadcrumbs_client_refresh", {
          workClient,
          // dataAssetsRoot: assetsRoot.data,
          // dataAssetsLastUploads: assetsLastUploads.data,
          // dataAssetsFavorites: assetsFavorites.data,
          // dataAssetsShared: assetsShared.data,
          explore: {
            dataAssetsExplore: assetsExplore.data,
            folderSelect: assetsExplore.folderselect,
            page: assetsExplore.page,
            limit: assetsExplore.limit
          },
          root: client.root,
          isFolderRelated: true,
          issuingUser: user.user
        });
        // dispatch(getBreadCrumbsByClient(workClient))
        // if (folderselect) {
        //   dispatch(getExplore(workClient, folderselect, 1, undefined, undefined, undefined, 20))
        // } else {
        //   dispatch(getRoot(workClient, root))
        // }
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "moved_folder_notif" })
        );
      })
      .catch(err => {
        dispatch({
          type: CLIENT_MOVE_FOLDER_FAILURE,
          payload: err
        });
      });
  };
};

export const deleteFolder = (
  workClient,
  folder,
  root,
  folderselect,
  history,
  handleHideCRUDFolder,
  navigate = true
) => {
  const {
    // assetsRoot,
    // assetsLastUploads,
    // assetsFavorites,
    // assetsShared,
    client,
    assetsExplore,
    authUser: user
  } = store.getState();

  return dispatch => {
    dispatch({ type: CLIENT_DELETE_FOLDER });
    BunkeyAPI({
      url: `/clients/${workClient}/objects/${folder}`,
      method: "DELETE"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({ type: CLIENT_DELETE_FOLDER_SUCCESS });
          const newFolderSelectId = resp.data.parent;
          const folders = store.getState().client.breadcrumb;
          const parentFolder = folders.find(r => r._id === newFolderSelectId);
          //if parentFolder is not home
          const path = parentFolder
            ? `/home/explore/${parentFolder._id}`
            : `/home`;
          // got to path
          if (navigate) {
            history.push(path);
          }

          Socket.getInstance().emit("breadcrumbs_client_refresh", {
            workClient,
            // dataAssetsRoot: assetsRoot.data,
            // dataAssetsLastUploads: assetsLastUploads.data,
            // dataAssetsFavorites: assetsFavorites.data,
            // dataAssetsShared: assetsShared.data,
            explore: {
              dataAssetsExplore: assetsExplore.data,
              folderSelect: folders.filter(
                f => f._id === newFolderSelectId && f.type !== root
              ).length
                ? newFolderSelectId
                : null,
              page: assetsExplore.page,
              limit: assetsExplore.limit
            },
            root: client.root,
            isFolderRelated: true,
            issuingUser: user.user
          });

          if (folderselect) {
            dispatch(getBreadCrumbsByClient(workClient, folderselect));
            if (folder === folderselect) {
              dispatch(
                getExplore(
                  workClient,
                  folderselect,
                  1,
                  undefined,
                  undefined,
                  undefined,
                  20
                )
              );
            } else {
              dispatch(getRoot(workClient, root));
            }
          } else {
            dispatch(getBreadCrumbsByClient(workClient));
            dispatch(getRoot(workClient, root));
            dispatch(getLastUploads(workClient, root));
          }
          handleHideCRUDFolder();
          // dispatch(getRoot(workClient, root))
          // dispatch(getFavorites(workClient, root))
          // dispatch(getLastUploads(workClient, root))
          // // dispatch(getGroupByClient(workClient))
        }
      })
      .catch(err => {
        dispatch({
          type: CLIENT_DELETE_FOLDER_FAILURE,
          payload: err
        });
      });
  };
};

export const setActiveView = (keyCollection, type) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(setRootActiveView(type));
        break;
      case "assetsLastUploads":
        dispatch(setLastUploadActiveView(type));
        break;
      case "assetsFavorites":
        dispatch(setFavoritesActiveView(type));
        break;
      case "assetsExplore":
        dispatch(setExploreActiveView(type));
        break;
      case "assetsShared":
        dispatch(setSharedActiveView(type));
        break;
      case "searcher":
        dispatch(setSearchActiveView(type));
        break;
      case "assetsPublicShared":
        dispatch(setPublicSharedActiveView(type));
        break;

      default:
        break;
    }
  };
};

export const setSelectItem = (keyCollection, item, from, indice) => {
  return dispatch => {
    const { verticalCount, horizontalCount } = store.getState().app;

    switch (keyCollection) {
      case "assetsLastUploads":
        dispatch(
          setSelectLastUploadAsset(
            item,
            indice,
            from,
            verticalCount,
            horizontalCount
          )
        );
        break;
      case "assetsFavorites":
        dispatch(
          setSelectFavoriteAsset(
            item,
            indice,
            from,
            verticalCount,
            horizontalCount
          )
        );
        break;
      case "assetsExplore":
        dispatch(
          setSelectExploreAsset(
            item,
            indice,
            from,
            verticalCount,
            horizontalCount
          )
        );
        break;
      case "assetsShared":
        dispatch(
          setSelectSharedAsset(
            item,
            indice,
            from,
            verticalCount,
            horizontalCount
          )
        );
        break;
      case "searcher":
        dispatch(
          setSelectSearcher(item, indice, from, verticalCount, horizontalCount)
        );
        break;
      case "assetsPublicShared":
        dispatch(
          setSelectPublicShared(
            item,
            indice,
            from,
            verticalCount,
            horizontalCount
          )
        );
        break;

      default:
        break;
    }
  };
};

export const unsetSelectItem = keyCollection => {
  return dispatch => {
    switch (keyCollection) {
      // El Gestor cierra su visor con la misma acción que el resto: la X y el
      // Escape del panel llaman acá, no al componente que lo abrió.
      case "rightsManager":
        dispatch({ type: CLOSE_RIGHTS_VIEWER });
        break;
      case "assetsLastUploads":
        dispatch(unsetSelectLastUploadAsset());
        break;
      case "assetsFavorites":
        dispatch(unsetSelectFavoriteAsset());
        break;
      case "assetsExplore":
        dispatch(unsetSelectExploreAsset());
        break;
      case "assetsShared":
        dispatch(unsetSelectSharedAsset());
        break;
      case "searcher":
        dispatch(unsetSelectSearcher());
        break;
      case "assetsPublicShared":
        dispatch(unsetSelectPublicShared());
        break;

      default:
        break;
    }
  };
};

export const deleteSelectedAsset = (
  keyCollection,
  workclient,
  id,
  intl,
  multiple = false
) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(deleteRootAsset(workclient, id, intl, multiple));
        break;
      case "assetsLastUploads":
        dispatch(deleteLastUploadAsset(workclient, id, intl, multiple));
        break;
      case "assetsFavorites":
        dispatch(deleteFavoritesAsset(workclient, id, intl, multiple));
        break;
      case "assetsExplore":
        dispatch(deleteExploreAsset(workclient, id, intl, multiple));
        break;
      case "assetsShared":
        dispatch(deleteSharedAsset(workclient, id, intl, multiple));
        break;
      case "searcher":
        dispatch(deleteSearchAsset(workclient, id, intl, multiple));
        break;

      default:
        break;
    }
  };
};
export const deleteSelectedAssets = (keyCollection, workclient, ids, intl) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(multiDeleteRootAsset(workclient, intl, ids));
        break;
      case "assetsLastUploads":
        dispatch(multiDeleteLastUploadAsset(workclient, intl, ids));
        break;
      case "assetsFavorites":
        dispatch(multiDeleteFavoritesAsset(workclient, intl, ids));
        break;
      case "assetsExplore":
        dispatch(multiDeleteExploreAsset(workclient, intl, ids));
        break;
      case "assetsShared":
        dispatch(multiDeleteSharedAsset(workclient, intl, ids));
        break;
      case "searcher":
        dispatch(multiDeleteSearchAsset(workclient, intl, ids));
        break;

      default:
        break;
    }
  };
};

export const setEditAsset = (keyCollection, workclient, asset, notf = null) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(setEditRootAsset(workclient, asset, notf));
        break;
      case "assetsLastUploads":
        dispatch(setEditLastUploadAsset(workclient, asset));
        break;
      case "assetsFavorites":
        dispatch(setEditFavoritesAsset(workclient, asset));
        break;
      case "assetsExplore":
        dispatch(setEditExploreAsset(workclient, asset));
        break;
      case "assetsShared":
        dispatch(setEditSharedAsset(workclient, asset));
        break;
      case "searcher":
        dispatch(setEditSearchAsset(workclient, asset));
        break;

      default:
        break;
    }
  };
};

// Patchea el rightsState/rightsStatus/dueDate de un asset en la lista que
// esté activa (RightsSeal, en la grilla, lee del mismo array `data`). No hace
// ningún request: se llama después de que RightsController.updateByAsset ya
// respondió, con esos mismos datos — sin esto, el sello de la grilla se queda
// con el estado viejo hasta recargar la página, aunque el panel de detalle
// (Copyright.js) sí muestre el valor nuevo.
export const updateAssetRightsInList = (assetId, rights) => {
  return dispatch => {
    dispatch({
      type: ASSET_RIGHTS_STATE_UPDATED,
      payload: {
        assetId,
        rightsState: rights.rightsState,
        rightsStatus: rights.rightsStatus,
        dueDate: rights.dueDate,
        createdDate: rights.createdDate,
        licenseFile: rights.licenseFile || null,
        rightsAssignedAt: rights.rightsAssignedAt || null
      }
    });
  };
};

export const setSelectEditAsset = (keyCollection, asset, editAssetTab) => {
  // Esta función selecciona un asset para ser modificado y recibe "editAssetTab" para
  // abrir la pestaña "editar" o "mover" segun corresponda en el drawer de editar asset

  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(setSelectEditRootAsset(asset, editAssetTab));
        break;
      case "assetsLastUploads":
        dispatch(setSelectEditLastUploadAsset(asset, editAssetTab));
        break;
      case "assetsFavorites":
        dispatch(setSelectEditFavoritesAsset(asset, editAssetTab));
        break;
      case "assetsExplore":
        dispatch(setSelectEditExploreAsset(asset, editAssetTab));
        break;
      case "assetsShared":
        dispatch(setSelectEditSharedAsset(asset, editAssetTab));
        break;
      case "searcher":
        dispatch(setSelectEditSearchAsset(asset, editAssetTab));
        break;

      default:
        break;
    }
  };
};

export const unsetSelectEditAsset = keyCollection => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(unsetSelectEditRootAsset());
        break;
      case "assetsLastUploads":
        dispatch(unsetSelectEditLastUploadAsset());
        break;
      case "assetsFavorites":
        dispatch(unsetSelectEditFavoritesAsset());
        break;
      case "assetsExplore":
        dispatch(unsetSelectEditExploreAsset());
        break;
      case "assetsShared":
        dispatch(unsetSelectEditSharedAsset());
        break;
      case "searcher":
        dispatch(unsetSelectEditSearchAsset());
        break;

      default:
        break;
    }
  };
};

export const setSelectExpandAsset = (keyCollection, asset) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsLastUploads":
        dispatch(setSelectExpandLastUploadAsset(asset));
        break;
      case "assetsFavorites":
        dispatch(setSelectExpandFavoritesAsset(asset));
        break;
      case "assetsExplore":
        dispatch(setSelectExpandExploreAsset(asset));
        break;
      case "assetsShared":
        dispatch(setSelectExpandSharedAsset(asset));
        break;
      case "searcher":
        dispatch(setSelectExpandSearchAsset(asset));
        break;
      case "assetsPublicShared":
        dispatch(setSelectExpandPublicSharedAsset(asset));
        break;

      default:
        break;
    }
  };
};

export const unsetSelectExpandAsset = keyCollection => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsLastUploads":
        dispatch(unsetSelectExpandLastUploadAsset());
        break;
      case "assetsFavorites":
        dispatch(unsetSelectExpandFavoritesAsset());
        break;
      case "assetsExplore":
        dispatch(unsetSelectExpandExploreAsset());
        break;
      case "assetsShared":
        dispatch(unsetSelectExpandSharedAsset());
        break;
      case "searcher":
        dispatch(unsetSelectExpandSearchAsset());
        break;
      case "assetsPublicShared":
        dispatch(unsetSelectExpandPublicSharedAsset());
        break;

      default:
        break;
    }
  };
};

export const setSelectShareAsset = (keyCollection, asset) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(setSelectShareRootAsset());
        break;
      case "assetsLastUploads":
        dispatch(setSelectShareLastUploadAsset(asset));
        break;
      case "assetsFavorites":
        dispatch(setSelectShareFavoritesAsset(asset));
        break;
      case "assetsExplore":
        dispatch(setSelectShareExploreAsset(asset));
        break;
      case "assetsShared":
        dispatch(setSelectShareSharedAsset(asset));
        break;
      case "searcher":
        dispatch(setSelectShareSearchAsset(asset));
        break;

      default:
        break;
    }
  };
};

export const unsetSelectShareAsset = keyCollection => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(unsetSelectShareRootAsset());
        break;
      case "assetsLastUploads":
        dispatch(unsetSelectShareLastUploadAsset());
        break;
      case "assetsFavorites":
        dispatch(unsetSelectShareFavoritesAsset());
        break;
      case "assetsExplore":
        dispatch(unsetSelectShareExploreAsset());
        break;
      case "assetsShared":
        dispatch(unsetSelectShareSharedAsset());
        break;
      case "searcher":
        dispatch(unsetSelectShareSearchAsset());
        break;

      default:
        break;
    }
  };
};

export const setUploading = (workclient, folderselect) => {
  const {
    // assetsRoot,
    // assetsLastUploads,
    // assetsFavorites,
    // assetsShared,
    client,
    assetsExplore,
    authUser: user
  } = store.getState();

  return dispatch => {
    dispatch({ type: CLIENT_SET_UPLOADING });
    if (folderselect) {
      Socket.getInstance().emit("breadcrumbs_client_refresh", {
        workClient: workclient,
        // dataAssetsRoot: assetsRoot.data,
        // dataAssetsLastUploads: assetsLastUploads.data,
        // dataAssetsFavorites: assetsFavorites.data,
        // dataAssetsShared: assetsShared.data,
        explore: {
          dataAssetsExplore: assetsExplore.data,
          folderSelect: assetsExplore.folderselect,
          page: assetsExplore.page,
          limit: assetsExplore.limit
        },
        root: client.root,
        issuingUser: user.user
      });
      // dispatch(getBreadCrumbsByClient(workclient))
      setTimeout(() => {
        dispatch(
          getExplore(
            workclient,
            folderselect,
            1,
            undefined,
            undefined,
            undefined,
            20
          )
        );
      }, 500);
    }
  };
};

export const unsetUploading = () => {
  return dispatch => {
    dispatch({ type: CLIENT_UNSET_UPLOADING });
  };
};

export const downloadProgress = value => {
  return dispatch => {
    dispatch({
      type: CLIENT_DOWNLOAD_PROGRESS,
      payload: value
    });
  };
};

export const MoveSelectedAsset = (
  keyCollection,
  workclient,
  asset,
  folder,
  folderselect,
  page,
  intl,
  multiple = false,
  limit
) => {
  const { root } = store.getState().client;
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(
          moveFolder(
            workclient,
            asset._id,
            folder,
            folderselect,
            root,
            intl,
            multiple
          )
        );
        setTimeout(() => {
          dispatch(getRoot(workclient, root));
        }, 500);
        break;
      case "assetsLastUploads":
        dispatch(
          moveLastUploadAsset(workclient, asset, folder, intl, multiple)
        );
        setTimeout(() => {
          dispatch(getLastUploads(workclient, folderselect, page));
        }, 500);
        break;
      case "assetsFavorites":
        dispatch(moveFavoritesAsset(workclient, asset, folder, intl, multiple));
        setTimeout(() => {
          dispatch(getFavorites(workclient, folderselect, page));
        }, 500);
        break;
      case "assetsExplore":
        dispatch(moveExploreAsset(workclient, asset, folder, intl, multiple));
        setTimeout(() => {
          dispatch(
            getExplore(
              workclient,
              folderselect,
              page,
              undefined,
              undefined,
              undefined,
              limit
            )
          );
        }, 500);
        break;
      case "assetsShared":
        dispatch(moveSharedAsset(workclient, asset, folder, intl, multiple));
        setTimeout(() => {
          dispatch(getShared(workclient, folderselect, page));
        }, 500);
        break;
      case "searcher":
        dispatch(moveSearchAsset(workclient, asset, folder, intl, multiple));
        break;

      default:
        break;
    }
  };
};

export const shareFolder = (
  workclient,
  folderId,
  emails,
  user,
  password,
  message,
  intl,
  expiresIn = false
) => {
  return dispatch => {
    dispatch({ type: CLIENT_SHARE_FOLDER });

    const sendEmails = emails.join(";");
    BunkeyAPI({
      url: `/shared`,
      method: "POST",
      data: {
        email: sendEmails,
        object: folderId,
        user: user,
        client: workclient,
        password: password,
        message: message,
        expiresIn: expiresIn ? expiresIn : 10
      }
    })
      .then(resp => {
        dispatch({
          type: CLIENT_SHARE_FOLDER_SUCCESS,
          payload: {
            data: folderId,
            headers: resp.headers
          }
        });
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "share-modal-folder-success" })
        );
      })
      .catch(err => {
        dispatch({
          type: CLIENT_SHARE_FOLDER_FAILURE,
          payload: err
        });
      });
  };
};

export const handleOrderBy = (
  keyCollection,
  workClient,
  orderBy,
  folderselect,
  page,
  limit
) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsExplore":
        // KAN-41 (punto 2): el mismo problema que 8a7e6e20 arregló para el
        // buscador, pero en la rama de carpetas, que quedó afuera de aquel fix.
        //
        // Al reordenar una carpeta se rompían dos cosas:
        //
        // - El `limit` lo manda el header, que lo lee de
        //   `state.assetsExplore.limit`. Ahí quedó congelado en 20 —el valor del
        //   initial-state— porque el reducer tiene comentada la línea que lo
        //   actualizaría con el 40 que usa Explore.handleGetData. Con 20
        //   elementos no se alcanza el umbral de 30 del InfiniteScroll y el
        //   scroll infinito se apaga.
        // - Se reusaba la página actual en vez de volver a la 1, así que el
        //   usuario quedaba parado en medio del orden nuevo, sin forma de llegar
        //   a lo que ahora iba antes.
        //
        // Se reordena desde la página 1 y con el mismo tamaño de página que usa
        // el flujo normal de la carpeta. El Math.max deja pasar una elección
        // mayor del usuario si algún día el reducer vuelve a guardar el limit.
        dispatch(
          getExplore(
            workClient,
            folderselect,
            1,
            orderBy,
            true,
            [],
            Math.max(limit || 0, LIMITE_PAGINA_CARPETA)
          )
        );
        break;
      case "searcher":
        const {
          searchText,
          searchType,
          isAdvancedSearchActive,
          advancedSearchValues
        } = store.getState().searcher;
        // Fix (feedback QA/Ricardo): al reordenar, reiniciar en la página 1 con el
        // MISMO tamaño de página (40) que usa el flujo normal de búsqueda. Antes se
        // reusaba `state.searcher.limit`, que quedaba congelado en 20; al caer bajo el
        // umbral (30) del InfiniteScroll, el scroll infinito se deshabilitaba tras
        // reordenar. Con 40 (>= 30) la paginación se re-arma correctamente.
        if (isAdvancedSearchActive) {
          dispatch(
            getAdvancedSearchResult(
              workClient,
              advancedSearchValues,
              1,
              orderBy,
              40
            )
          );
        } else {
          dispatch(
            getSearchResult(
              workClient,
              searchText,
              searchType,
              1,
              orderBy,
              null,
              40
            )
          );
        }

        break;

      default:
        break;
    }
  };
};

export const handlePaginationNumber = (
  keyCollection,
  workClient,
  page,
  limit,
  orderBy,
  folderselect
) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsExplore":
        dispatch(
          getExplore(workClient, folderselect, page, orderBy, true, [], limit)
        );
        break;
      case "searcher":
        const {
          searchText,
          searchType,
          isAdvancedSearchActive,
          advancedSearchValues
        } = store.getState().searcher;
        if (isAdvancedSearchActive) {
          dispatch(
            getAdvancedSearchResult(
              workClient,
              advancedSearchValues,
              page,
              orderBy,
              limit
            )
          );
        } else {
          dispatch(
            getSearchResult(
              workClient,
              searchText,
              searchType,
              page,
              orderBy,
              null,
              limit
            )
          );
        }

        break;
      default:
        break;
    }
  };
};

export const putCompanyLogo = (futureFileURL, workclient) => {
  return dispatch => {
    dispatch({ type: CLIENT_CHANGE_LOGO });

    BunkeyAPI({
      url: `clients/${workclient}`,
      method: "PUT",
      data: {
        acountSetting: {
          logo: futureFileURL,
          lenguage: "es"
        }
      }
    })
      .then(resp => {
        dispatch(getCompanyLogo(workclient));
      })
      .catch(err => {
        dispatch({
          type: CLIENT_CHANGE_LOGO_FAILURE,
          payload: err
        });
      });
  };
};

export const getCompanyLogo = workclient => {
  return dispatch => {
    BunkeyAPI({
      url: `clients/${workclient}`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: CLIENT_CHANGE_LOGO_SUCCESS,
          payload: resp.data.acountSetting.logo
        });
      })
      .catch(err => {
        dispatch({
          type: CLIENT_CHANGE_LOGO_FAILURE,
          payload: err
        });
      });
  };
};

export const setCheckItem = (keyCollection, item) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(setCheckRootAsset(item));
        break;
      case "assetsLastUploads":
        dispatch(setCheckLastUploadAsset(item));
        break;
      case "assetsFavorites":
        dispatch(setCheckFavoritesAsset(item));
        break;
      case "assetsExplore":
        dispatch(setCheckExploreAsset(item));
        break;
      case "assetsShared":
        dispatch(setCheckSharedAsset(item));
        break;
      case "searcher":
        dispatch(setCheckSearcherAsset(item));
        break;

      default:
        break;
    }
  };
};

export const unsetCheckItem = (keyCollection, item) => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(unsetCheckRootAsset(item));
        break;
      case "assetsLastUploads":
        dispatch(unsetCheckLastUploadAsset(item));
        break;
      case "assetsFavorites":
        dispatch(unsetCheckFavoritesAsset(item));
        break;
      case "assetsExplore":
        dispatch(unsetCheckExploreAsset(item));
        break;
      case "assetsShared":
        dispatch(unsetCheckSharedAsset(item));
        break;
      case "searcher":
        dispatch(unsetCheckSearcherAsset(item));
        break;

      default:
        break;
    }
  };
};

export const activateMutipleSelectFunctions = keyCollection => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(activateRootOptions());
        break;
      case "assetsLastUploads":
        dispatch(activateLastUploadsOptions());
        break;
      case "assetsFavorites":
        dispatch(activateFavoritesOptions());
        break;
      case "assetsExplore":
        dispatch(activateExploreOptions());
        break;
      case "assetsShared":
        dispatch(activateSharedOptions());
        break;
      case "searcher":
        dispatch(activateSearchOptions());
        break;

      default:
        break;
    }
  };
};

export const deactivateMutipleSelectFunctions = keyCollection => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(deactivateRootOptions());
        break;
      case "assetsLastUploads":
        dispatch(deactivateLastUploadsOptions());
        break;
      case "assetsFavorites":
        dispatch(deactivateFavoritesOptions());
        break;
      case "assetsExplore":
        dispatch(deactivateExploreOptions());
        break;
      case "assetsShared":
        dispatch(deactivateSharedOptions());
        break;
      case "searcher":
        dispatch(deactivateSearchOptions());
        break;

      default:
        break;
    }
  };
};

export const multipleOptionsIsDone = keyCollection => {
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(isDoneMultipeRootOptions());
        break;
      case "assetsLastUploads":
        dispatch(isDoneMultipeLastUploadsOptions());
        break;
      case "assetsFavorites":
        dispatch(isDoneMultipeFavoritesOptions());
        break;
      case "assetsExplore":
        dispatch(isDoneMultipeExploreOptions());
        break;
      case "assetsShared":
        dispatch(isDoneMultipeSharedOptions());
        break;
      case "searcher":
        dispatch(isDoneMultipeSearchOptions());
        break;

      default:
        break;
    }
  };
};

export const setPidExistsConfirmAssets = pid => {
  return dispatch => {
    dispatch({
      type: CLIENT_SET_PID,
      payload: pid
    });
  };
};

export const createClient = (
  dni,
  companyName,
  agent,
  phone,
  email,
  modules,
  dartCustomField,
  contractedUsers,
  contractedSpace,
  clientType,
  businessType
) => {
  return dispatch => {
    dispatch({ type: CREATE_CLIENT_LIST });

    BunkeyAPI({
      url: `/admin/clients`,
      method: "POST",
      data: {
        dni: dni,
        name: companyName,
        agent: agent,
        phone: phone,
        email: email,
        clientType: clientType,
        businessType: businessType,
        acountSetting: {
          logo:
            "https://vignette.wikia.nocookie.net/gameofthrones/images/e/ed/Night%27s-Watch-Main-Shield.PNG"
        },
        modules: modules,
        dartCustomField: dartCustomField,
        contractedUsers: contractedUsers,
        contractedSpace: contractedSpace
      }
    })
      .then(resp => {
        dispatch({
          type: CREATE_CLIENT_LIST_SUCCESS,
          payload: {
            payload: resp.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CREATE_CLIENT_LIST_FAILURE
        });
      });
  };
};

export const deleteClient = clientId => {
  return dispatch => {
    dispatch({ type: DELETE_CLIENT_LIST });

    BunkeyAPI({
      url: `/admin/clients/${clientId}`,
      method: "DELETE"
    })
      .then(resp => {
        if (resp.status === 204) {
          dispatch({ type: DELETE_CLIENT_LIST_SUCCESS });
        } else {
          dispatch({ type: DELETE_CLIENT_LIST_FAILURE });
        }
      })
      .catch(err => {
        dispatch({
          type: DELETE_CLIENT_LIST_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const updateClientes = (
  clientId,
  dni,
  companyName,
  agent,
  phone,
  email,
  modules,
  dartCustomField,
  media,
  statusAsset,
  contractedUsers,
  contractedSpace,
  clientType,
  businessType
) => {
  return dispatch => {
    dispatch({ type: UPDATE_CLIENT_LIST });

    BunkeyAPI({
      url: `/admin/clients/${clientId}`,
      method: "PUT",
      data: {
        dni: dni,
        name: companyName,
        agent: agent,
        phone: phone,
        email: email,
        clientType: clientType,
        businessType: businessType,
        modules: modules,
        dartCustomField: dartCustomField,
        contractedUsers: contractedUsers,
        contractedSpace: contractedSpace
      }
    })
      .then(resp => {
        dispatch({
          type: UPDATE_CLIENT_LIST_SUCCESS,
          payload: {
            data: {
              dni: dni,
              name: companyName,
              agent: agent,
              phone: phone,
              email: email,
              clientType: clientType,
              businessType: businessType,
              modules: modules,
              dartCustomField: dartCustomField,
              contractedUsers: contractedUsers,
              contractedSpace: contractedSpace,
              media: media,
              statusAsset: statusAsset
            }
          }
        });
      })
      .catch(err => {
        dispatch({
          type: UPDATE_CLIENT_LIST_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const activateModules = (clientId, modules) => {
  return dispatch => {
    BunkeyAPI({
      url: `/admin/modules/${clientId}`,
      data: {
        ...modules
      },
      method: "POST"
    })
      .then(resp => {
        if (resp.status === 204) {
        } else {
        }
      })
      .catch(err => { });
  };
};
/**
 *
 * @param {*} qtyFilesError
 * @name setQtyFilesError
 * @author Victor Smith
 */
export const setQtyFilesError = qtyFilesError => {
  return dispatch => {
    dispatch({
      type: SET_QTY_FILES_ERROR,
      payload: {
        qtyFilesError
      }
    });
  };
};
/**
 *
 * @param {*} attemps
 * @name handleUserAttemps
 * @author Victor Smith
 */
export const handleUserAttemps = attemps => {
  return dispatch => {
    dispatch({
      type: HANDLE_USER_ATTEMPS,
      payload: { attemps }
    });
  };
};
/**
 *
 * @param {*} numberAttemps
 * @name setNumberAttemps
 * @author Victor Smith
 */
export const setNumberAttemps = numberAttemps => {
  return dispatch => {
    dispatch({
      type: SET_NUMBER_ATTEMPS,
      payload: { numberAttemps }
    });
  };
};

export const handleIsTourOpen = isTourOpen => {
  return dispatch => {
    dispatch({
      type: HANDLE_IS_TOUR_OPEN,
      payload: { isTourOpen }
    });
  };
};

export const handleFetchingSauronReport = isFetchingSauronReport => {
  return dispatch => {
    dispatch({
      type: HANDLE_IS_FETCHING_SAURON_REPORT,
      payload: { isFetchingSauronReport }
    });
  };
};

export const handleShowNewVersionAsset = payload => {
  return dispatch => {
    dispatch({
      type: SHOW_VERSION_ASSET,
      payload
    });
  };
};

export const handleHideNewVersionAsset = () => {
  return dispatch => {
    dispatch({
      type: HIDE_VERSION_ASSET
    });
  };
};

export const addFileNewVersionAsset = file => {
  return dispatch => {
    dispatch({
      type: ADD_FILE_VERSION_ASSET,
      payload: { file }
    });
  };
};

export const removeFileNewVersionAsset = uuid => {
  return dispatch => {
    dispatch({
      type: REMOVE_FILE_VERSION_ASSET,
      payload: { uuidtoRemove: uuid }
    });
  };
};

export const updateFileProgressVersionAsset = (file, e) => {
  return dispatch => {
    dispatch({
      type: UPDATE_FILE_PROGRESS_VERSION_ASSET,
      payload: { file, e }
    });
  };
};

export const setUploadObjectToFileVersionAsset = (file, uploadObject) => {
  return dispatch => {
    dispatch({
      type: SET_UPLOAD_OBJECT_TO_FILE_VERSION_ASSET,
      payload: {
        file,
        uploadObject
      }
    });
  };
};

export const setErrorStateToFileVersionAsset = data => {
  return dispatch => {
    dispatch({
      type: SET_ERROR_STATE_TO_FILE_VERSION_ASSET,
      payload: { data }
    });
  };
};
export const setSuccessStateToFileVersionAsset = asset => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SET_SUCCESS_STATE_TO_FILE_VERSION_ASSET,
        payload: {
          asset
        }
      });
      resolve();
    });
  };
};

export const setIsUploadingVersion = () => {
  return dispatch => {
    dispatch({
      type: SET_IS_UPLOADING_VERSION
    });
  };
};

export const unsetIsUploadingVersion = () => {
  return dispatch => {
    dispatch({ type: CLIENT_UNSET_UPLOADING });
    dispatch({
      type: UNSET_IS_UPLOADING_VERSION
    });
  };
};

export const emptyAssetVersion = () => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: EMPTY_VERSION_ASSET
      });

      resolve();
    });
  };
};

export const setVersionTagsAssetVersion = versionTags => {
  return dispatch => {
    dispatch({
      type: SET_VERSION_TAGS_VERSION_ASSET,
      payload: { versionTags }
    });
  };
};

export const doneUploadVersionAsset = (
  itemSelected,
  workclient,
  root,
  keyCollection,
  from,
  searchService,
  folderselect
) => {
  return (dispatch, getState) => {
    const { assetsExplore, client, authUser: user } = getState();
    dispatch(unsetIsUploadingVersion());
    dispatch({ type: CLIENT_UNSET_UPLOADING });

    dispatch(emptyAssetVersion());

    dispatch(
      setSelectItem(
        keyCollection,
        itemSelected.document,
        from,
        itemSelected.document.indice
      )
    );

    if (
      searchService &&
      searchService.location &&
      searchService.location.pathname.includes("result")
    ) {
      dispatch(
        getSearchResult(
          workclient,
          searchService.searchText,
          searchService.searchType,
          searchService.page,
          searchService.orderBy
        )
      );
    }

    if (assetsExplore.folderselect) {
      dispatch(
        getExplore(workclient, assetsExplore.folderselect, assetsExplore.page)
      );

      Socket.getInstance().emit("breadcrumbs_client_refresh", {
        workClient: workclient,
        // dataAssetsRoot: assetsRoot.data,
        // dataAssetsLastUploads: assetsLastUploads.data,
        // dataAssetsFavorites: assetsFavorites.data,
        // dataAssetsShared: assetsShared.data,
        explore: {
          dataAssetsExplore: assetsExplore.data,
          folderSelect: assetsExplore.folderselect,
          page: assetsExplore.page
        },
        root: client.root,
        issuingUser: user.user
      });
    }

    dispatch(setSelectedItem(itemSelected.document._id));

    dispatch(getLastUploads(workclient, root));
    //
    dispatch(getFavorites(workclient, root));
    dispatch(getShared(workclient, root));
    dispatch(getPlanServices());

    // this.props.setUploading(workclient, folderselect)
  };
};

export const cancelUploadVersion = asset => {
  asset.uploadObject.abort();
  return dispatch => {
    dispatch({ type: CLIENT_UNSET_UPLOADING });
    dispatch({
      type: CANCEL_UPLOAD_VERSION,
      payload: {
        asset
      }
    });
  };
};

export const resetUploadByError = asset => {
  return dispatch => {
    dispatch({ type: CLIENT_UNSET_UPLOADING });
    dispatch({
      type: ERROR_UPLOAD_VERSION
    });
  };
};

export const setTagsAssetVersion = objectTag => {
  return dispatch => {
    dispatch({
      type: SET_TAGS_UPLOAD_VERSION,
      payload: { tags: objectTag.tags }
    });
  };
};

export const removeTagAssetVersion = tag => {
  return dispatch => {
    dispatch({
      type: REMOVE_TAG_ASSET_VERSION,
      payload: { tagToRemove: tag }
    });
  };
};

export const setUsersOption = users => {
  return dispatch => {
    dispatch({
      type: SET_USERS_OPTIONS,
      payload: { usersOption: users }
    });
  };
};

export const setMentionedUsers = users => {
  return dispatch => {
    dispatch({
      type: SET_MENTIONED_USERS,
      payload: { mentionedUsers: users }
    });
  };
};

export const createClientMedia = (clientId, media) => {
  return dispatch => {
    dispatch({ type: CREATE_CLIENT_MEDIA });

    BunkeyAPI({
      url: `/clients/${clientId}/addMediaToClient`,
      method: "POST",
      data: media
    })
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: CREATE_CLIENT_MEDIA_SUCCESS,
          payload: {
            data: {
              media: data.media
            }
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CREATE_CLIENT_MEDIA_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const createClientStatus = (clientId, status) => {
  return dispatch => {
    dispatch({ type: CREATE_CLIENT_STATUS });

    BunkeyAPI({
      url: `/clients/${clientId}/addStatusToClient`,
      method: "POST",
      data: status
    })
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: CREATE_CLIENT_STATUS_SUCCESS,
          payload: {
            data: {
              statusAsset: data.statusAsset
            }
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CREATE_CLIENT_STATUS_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const deleteClientMedia = (clientId, mediaId) => {
  return dispatch => {
    dispatch({ type: DELETE_CLIENT_MEDIA });

    BunkeyAPI({
      url: `/clients/${clientId}/media/${mediaId}`,
      method: "DELETE"
    })
      .then(resp => {
        dispatch({
          type: DELETE_CLIENT_MEDIA_SUCCESS,
          payload: {
            data: {
              deletedMediaId: mediaId
            }
          }
        });
      })
      .catch(err => {
        dispatch({
          type: DELETE_CLIENT_MEDIA_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};

export const deleteClientStatus = (clientId, statusId) => {
  const { statusAsset } = store.getState().comments.itemSelected.document;
  return dispatch => {
    dispatch({ type: DELETE_CLIENT_STATUS });

    BunkeyAPI({
      url: `/clients/${clientId}/status/${statusId}`,
      method: "DELETE"
    })
      .then(resp => {
        dispatch({
          type: DELETE_CLIENT_STATUS_SUCCESS,
          payload: {
            data: {
              deletedStatusId: statusId
            }
          }
        });

        if (statusAsset && statusAsset._id === statusId) {
          dispatch({
            type: RESET_STATUS_ASSET
          });
        }
      })
      .catch(err => {
        dispatch({
          type: DELETE_CLIENT_STATUS_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};
export const cleanClientData = () => {
  return dispatch => {
    dispatch({ type: CLIENT_DATA_CLEAN });
  };
};

export const shareFolderReset = () => dispatch =>
  dispatch({ type: SHARE_FOLDER_RESET });

export const moveMultiSelectedAsset = (
  keyCollection,
  workclient,
  ids,
  folder,
  folderselect,
  page,
  intl,
  limit
) => {
  const { root } = store.getState().client;
  return dispatch => {
    switch (keyCollection) {
      case "assetsRoot":
        dispatch(moveMultiselectRootAsset(workclient, ids, folder, intl));
        setTimeout(() => {
          dispatch(getRoot(workclient, root));
        }, 500);
        break;
      case "assetsLastUploads":
        dispatch(moveMultiselectLastUploadAsset(workclient, ids, folder, intl));
        setTimeout(() => {
          dispatch(getLastUploads(workclient, folderselect, page));
        }, 500);
        break;
      case "assetsFavorites":
        dispatch(moveMultiselectFavoritesAsset(workclient, ids, folder, intl));
        setTimeout(() => {
          dispatch(getFavorites(workclient, folderselect, page));
        }, 500);
        break;
      case "assetsExplore":
        dispatch(moveMultiselectExploreAsset(workclient, ids, folder, intl));
        setTimeout(() => {
          dispatch(
            getExplore(
              workclient,
              folderselect,
              page,
              undefined,
              undefined,
              undefined,
              limit
            )
          );
        }, 500);
        break;
      case "assetsShared":
        dispatch(moveMultiselectSharedAsset(workclient, ids, folder, intl));
        setTimeout(() => {
          dispatch(getShared(workclient, folderselect, page));
        }, 500);
        break;
      case "searcher":
        dispatch(moveMultiselectSearchAsset(workclient, ids, folder, intl));
        break;

      default:
        break;
    }
  };
};

export const updateMetadataClient = metadata => {
  return dispatch => {
    dispatch({
      type: UPDATE_METADATA_CLIENT,
      payload: metadata
    });
  };
};

export const clientRootFolderNavbar = data => {
  return dispatch => {
    dispatch({
      type: CLIENT_ROOT_FOLDER_NAVBAR,
      payload: data
    });
  };
};
